'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Promptable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _RootNode = require('../utils/RootNode');

var _UIFullScreen = require('../dialog/UIFullScreen');

var _UIFullScreen2 = _interopRequireDefault(_UIFullScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param  {React.Component}
 * @param  {HTMLElement}
 * @param  {?Object}
 * @param  {?React.Component} parentComponent - ReactComponent instance
 * @return {Promise}
 */
function doPrompt(Component, contextRootNode, additionalProps, parentComponent) {
  var element = document.createElement('div');

  var promiseCallback = function promiseCallback(resolve, reject) {
    var WrappedComponent = _react2.default.createElement(
      _UIFullScreen2.default,
      { 'data-layer-for': 'Promptable', rootNode: contextRootNode },
      _react2.default.createElement(Component, _extends({}, additionalProps, { onConfirm: resolve, onReject: reject }))
    );

    if (parentComponent) {
      _reactDom2.default.unstable_renderSubtreeIntoContainer(parentComponent, WrappedComponent, element);
    } else {
      _reactDom2.default.render(WrappedComponent, element);
    }
  };

  // Maintain backward compatibility in apps that expect a Q promise
  var promise = window.Q ? new window.Q.Promise(promiseCallback) : new Promise(promiseCallback);

  return promise.finally(function () {
    _reactDom2.default.unmountComponentAtNode(element);
  });
}

/**
 * @param  {React.Component}
 * @param  {HTMLElement}
 * @return {(additionalProps: ?Object) => Promise}
 */
function Promptable(Component) {
  var contextRootNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _RootNode.getDefaultNode)();

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return doPrompt.apply(undefined, [Component, contextRootNode].concat(args));
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/decorators/Promptable.js
// module id = 148
// module chunks = 3 4 5